import { useEffect } from 'react'

import { type FilterManagerContextValues } from '@webapp/components/FilterManager/FilterManagerContext'
import { type FilterManagerFilter } from '@webapp/components/FilterManager/types'

interface IUseRemoveUnresolvedLegalEntityFilterProps {
  legalEntityFilter: FilterManagerFilter | undefined
  removeFilter: FilterManagerContextValues['removeFilter']
}

/**
 * Companion to `useResolveLegalEntityFilter`: removes a `legal_entity` filter
 * whose URL id did not resolve; FilterManager would otherwise still send its
 * `paramValue`.
 */
export const useRemoveUnresolvedLegalEntityFilter = ({
  legalEntityFilter,
  removeFilter,
}: IUseRemoveUnresolvedLegalEntityFilterProps) => {
  useEffect(() => {
    if (legalEntityFilter && !legalEntityFilter.value) {
      removeFilter(legalEntityFilter)
    }
    // removeFilter is not memoised by useFilterManager
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [legalEntityFilter])
}
